import { graphql } from "react-relay";

export const QUERY = graphql`
	query personalizedNotificationTemplates_PersonalizedNotificationTemplatesQuery {
		...personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesListFragment
	}
`;
